<template>
  <div style="width:100%;float:left;" :class="{ 'embedded-charge-table': embedded }">
    <component :is="embedded ? 'div' : 'CCard'">
      <CCardHeader v-if="!embedded" color="secondary" @click="collapsed = !collapsed">Additional Charges/Discounts
        <div class="card-header-actions">
          <CLink class="card-header-action btn-minimize">
            <CIcon :name="`cil-chevron-${collapsed ? 'bottom' : 'top'}`"/>
          </CLink>
        </div>
      </CCardHeader>
      <CCollapse :show="embedded || collapsed" :duration="embedded ? 0 : 400">
        <CCardBody>
          <div class="col-12 text-center" style="color:red;">
            Check the box on the left to apply an additional charge.
          </div>
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Charge</th>
                <th>Code</th>
                <th>Location</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in additionalCharges" :key="item.additional_charges_id">
                <td>
                  <CButton
                    style="width:20px;height:20px;padding:0;"
                    v-if="checkColor(item) === 'yes'"
                    color="success"
                    @click="clickCharge(item)"
                    :disabled="isChargeLocked(item)"
                  >
                    <CIcon size="sm" name="cil-check" />
                  </CButton>
                  <CButton
                    style="width:20px;height:20px;padding:0;"
                    v-else
                    color="outline-success"
                    @click="clickCharge(item)"
                    :disabled="isChargeLocked(item)"
                  >
                    <div style="width:15px;height:20px;"></div>
                  </CButton>
                </td>
                <td>{{item.charge_name}}</td>
                <td>{{item.charge_code}}</td>
                <td>
                  <v-select v-if="item.location_options" :options="item.location_options" v-model="item.location" @input="chargeLocationChanged(item)"></v-select>
                </td>
                <td>{{item.price}}</td>
              </tr>
            </tbody>
          </table>
        </CCardBody>
      </CCollapse>
    </component>
  </div>
</template>
<script>
var methods = {}

methods.checkColor = function (item) {
  var col = ''
  if (!this.group.additional_charges) {
    return col
  }
  this.group.additional_charges.forEach(function (charge) {
    if (parseInt(charge.additional_charges_id) === parseInt(item.additional_charges_id)) {
      col = 'yes'
    }
  })
  return col
}

methods.isFastLaneCharge = function (item) {
  return parseInt(item.fastlane_charge || 0) === 1
}

methods.isChargeLocked = function (item) {
  return this.isFastLaneCharge(item) && parseInt(this.group.fast_lane || 0) === 1
}

methods.syncFastLaneCharge = function () {
  if (!this.group) return

  if (!this.group.additional_charges) {
    this.$set(this.group, 'additional_charges', [])
  }

  const configuredCharge = (this.additionalCharges || []).find((item) => this.isFastLaneCharge(item))
  const existingIndex = this.group.additional_charges.findIndex((charge) => parseInt(charge.fastlane_charge || 0) === 1)

  if (!configuredCharge) {
    if (existingIndex > -1) {
      this.group.additional_charges.splice(existingIndex, 1)
    }
    return
  }

  const matchedIndex = this.group.additional_charges.findIndex((charge) =>
    parseInt(charge.additional_charges_id) === parseInt(configuredCharge.additional_charges_id) ||
    parseInt(charge.fastlane_charge || 0) === 1
  )

  if (parseInt(this.group.fast_lane || 0) === 1) {
    const existingCharge = matchedIndex > -1 ? this.group.additional_charges[matchedIndex] : null
    const normalizedCharge = {
      ...configuredCharge,
      location: existingCharge && existingCharge.location
        ? existingCharge.location
        : (configuredCharge.location || (configuredCharge.location_options && configuredCharge.location_options.length ? configuredCharge.location_options[0] : '')),
      fastlane_charge: 1
    }

    if (matchedIndex > -1) {
      this.group.additional_charges.splice(matchedIndex, 1, normalizedCharge)
    } else {
      this.group.additional_charges.push(normalizedCharge)
    }
  } else if (matchedIndex > -1) {
    this.group.additional_charges.splice(matchedIndex, 1)
  }
}

methods.clickCharge = function (item) {
  if (this.isChargeLocked(item)) {
    return
  }

  var found = false
  var i = 0
  var foundIndex = ''
  this.group.additional_charges.forEach(function (charge) {
    if (charge.additional_charges_id === item.additional_charges_id) {
      found = true
      foundIndex = i
    }
    i++
  })
  if (!found) {
    this.group.additional_charges.push(item)
  } else {
    this.group.additional_charges.splice(foundIndex, 1)
  }
  this.$emit('input-changed')
}

methods.chargeLocationChanged = function (item) {
  var selected = (this.group.additional_charges || []).find(function (charge) {
    return parseInt(charge.additional_charges_id) === parseInt(item.additional_charges_id)
  })
  if (selected) selected.location = item.location || ''
  this.$emit('input-changed')
}

methods.loadAdditionalCharges = function () {
  let self = this

  let programId = self.group && self.group.program_info
    ? (self.group.program_info.program_id || self.group.program_info.id)
    : null

  if (!programId) {
    self.additionalCharges = []
    return
  }

  axios.get(this.$apiAdress + '/api/additional_charges/for_program/' + programId + '?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.additionalCharges = response.data || []
      self.syncFastLaneCharge()
    })
    .catch(function (error) {
      console.log(error)
      self.additionalCharges = []
    })
}

export default {
  name: "AdditionalChargesTable",
  props: {
    group: {
      type: Object,
      required: true
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data(){
      return{
        fields: ['check', 'charge_name', 'price'],
        additionalCharges: [],
        collapsed: false
      }
  },
  mounted() {
    this.loadAdditionalCharges()
  },
  computed: {},
  watch: {
    'group.fast_lane': function () {
      this.syncFastLaneCharge()
    }
  },
  methods: methods
}
</script>
<style scoped></style>
